import { c as _c } from "react/compiler-runtime";
import type { CollectDocumentConfig } from '@onefootprint/request-types';
import { useTranslation } from 'react-i18next';
const useGetDocumentRequestLabel = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "transfer.documentRequestKind"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  let t1;
  if ($[1] !== t) {
    t1 = kind => {
      const translations = {
        identity: t(_temp),
        proof_of_address: t(_temp2),
        proof_of_ssn: t(_temp3),
        selfie: t(_temp4),
        custom: t(_temp5)
      };
      if (kind in translations) {
        return translations[kind];
      }
      return t(_temp6);
    };
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default useGetDocumentRequestLabel;
function _temp($) {
  return $.identity;
}
function _temp2($_0) {
  return $_0.proofOfAddress;
}
function _temp3($_1) {
  return $_1.proofOfSsn;
}
function _temp4($_2) {
  return $_2.selfie;
}
function _temp5($_3) {
  return $_3.unknown;
}
function _temp6($_4) {
  return $_4.unknown;
}